import { render, staticRenderFns } from "./SwitchLang.vue?vue&type=template&id=1f3019df&scoped=true"
import script from "./SwitchLang.vue?vue&type=script&lang=js"
export * from "./SwitchLang.vue?vue&type=script&lang=js"
import style0 from "./SwitchLang.vue?vue&type=style&index=0&id=1f3019df&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f3019df",
  null
  
)

export default component.exports